<template>
  <div class="admin-menus">
    <header-title title="Orden Cartas"></header-title>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            outlined
            dense
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="menus"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.menu_image`]="{ item }">
            <div v-if="isHomeVersionPremium" class="menu-image">
              <img
                v-if="item.menu_image"
                :src="showImageOrFallbackImage(item.menu_image)"
                @error="item.menu_image = fallbackImage"
                :alt="item.menu_image"
              />
              <img v-else :src="fallbackImage" :alt="item.name" />
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            {{ getMenuType(item.type) }}
          </template>
          <template v-slot:[`item.sort`]="{ item }">
            <v-text-field
              v-model="item.sort"
              :rules="validationRules.sort"
              required
              placeholder="Escribe el orden"
              type="number"
            ></v-text-field>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-btn @click="updateMenu(item)">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { MenusOrderTableHeader } from "@/utils/tableHeaderconstants";
import {
  uiMenuOrderCollection,
  updateUiMenuOrder
} from "@/collections/uiMenuOrder";
export default {
  components: {
    HeaderTitle
  },
  name: "MenusOrder",
  data() {
    return {
      search: "",
      headers: [...MenusOrderTableHeader],
      uiMenuOrderCollection: [],
      selectedMenuType: "",
      selectedMenuOrder: "",
      selectedMenuId: "",
      validationRules: {
        sort: [
          v => !!v || "Orden es requerido",
          v => (!!v && parseInt(v) > 0) || "Introduce un orden positivo"
        ]
      }
    };
  },
  firestore() {
    return {
      uiMenuOrderCollection: uiMenuOrderCollection
        .where("active", "==", true)
        .orderBy("sort", "asc")
    };
  },
  computed: {
    menus() {
      return this.uiMenuOrderCollection;
    }
  },
  methods: {
    getMenuType(type) {
      if (type === "menus") {
        return "Carta";
      }

      if (type === "menu_group") {
        return "Menu";
      }

      return "Carta Principal";
    },
    async updateMenu(menu) {
      try {
        await updateUiMenuOrder(menu.id, { sort: parseInt(menu.sort) });
        this.showSuccessMessage("Orden actualizado");
      } catch (error) {
        this.setlogError(
          "update_ui_menu_order",
          "Obtained error message in updateMenu()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
